export const PROCESS_LOADING = "PROCESS_LOADING";
export const PROCESS_FINISHED = "PROCESS_FINISHED";